import client from "./client";

export interface DeleteProfileResponse {
  success: boolean;
  message: string;
  access_revoked: boolean;
  user_content: "pending_review";
  retained_records?: string[];
  deletion_request?: {
    id: number;
    status: "access_revoked";
    data_erasure_status: "pending_review";
    requested_at?: string;
    access_revoked_at?: string;
  };
}

/**
 * Отзывает доступ к профилю текущего Bearer-пользователя и создаёт запрос
 * на проверку удаления его контента. Идентификатор пользователя берётся
 * только из сессии; user_id с клиента не передаётся.
 */
export async function deleteCurrentProfile(
  password: string
): Promise<DeleteProfileResponse> {
  const { data } = await client.post<DeleteProfileResponse>(
    "/user/delete_profile.php",
    { confirm: true, password }
  );
  return data;
}
